<mat-dialog-content>
  <div class="item-modal">
    <span class="modal-heading">Importing New Item</span>
    <mat-stepper linear #stepper>
      <mat-step [stepControl]="firstFormGroup" [editable]="true">
        <form [formGroup]="firstFormGroup">
          <ng-template matStepLabel>Set up Item</ng-template>
          @if (data.isExternalItemNumberGroup) {
            <div class="item-name">Commodity Code {{ data.itemNumber }}</div>
          }
          @for (item of data.unimportedItems; track item) {
            <div [ngClass]="data.isExternalItemNumberGroup ? 'external-item-item-name' : 'item-name'">
              {{ item.customerDescription }} / {{ item.fulfillmentDescription }}
            </div>
          }
          <div class="section">
            <mat-label>Prep Location</mat-label>
            <mat-form-field appearance="fill" class="prep-dept-dropdown">
              <mat-label>Who will prepare this item?</mat-label>
              <mat-select formControlName="prepLocation" required (selectionChange)="prepDepartmentChange()">
                @for (pl of prepLocations; track pl) {
                  <mat-option value="{{ pl.prepLocationTypeName }}">{{ pl.prepLocationTypeName }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="section">
            <mat-label>Item Times</mat-label>
            <div class="counter-row">
              <div class="counter">
                <mat-label>Lead Time</mat-label>
                <increment-input [(value)]="leadTime" [step]="1" [min]="0" [max]="24" unit="Hours"> </increment-input>
              </div>
              <div class="counter">
                <mat-label>Prep Time</mat-label>
                <increment-input [(value)]="prepTime" [step]="1" [min]="0" [max]="1440" unit="Minutes">
                </increment-input>
              </div>
              <div class="counter">
                <mat-label>Post Prep Buffer</mat-label>
                <increment-input [(value)]="postPrepTime" [step]="1" [min]="0" [max]="1440" unit="Minutes">
                </increment-input>
              </div>
            </div>
          </div>
          <div class="section pickup-dates">
            <mat-label>Pickup Dates</mat-label>
            <div class="multi-radio">
              <mat-radio-group
                class="radio-group"
                [(ngModel)]="isDateRestricted"
                (change)="pickupRestrictionButton($event)"
                name="date-restriction">
                <mat-radio-button [value]="false" [checked]="!isDateRestricted" name="date-restriction">
                  Any day
                </mat-radio-button>
                <mat-radio-button checked [value]="true" [checked]="isDateRestricted" name="date-restriction">
                  Set a date range
                </mat-radio-button>
              </mat-radio-group>
              @if (isDateRestricted) {
                <form class="date-restrictions" [formGroup]="pickupDatesForm">
                  <div class="date-picker">
                    <mat-label [class.disabled-pickup-date]="!isDateRestricted">Start date</mat-label>
                    <mat-form-field appearance="fill">
                      <mat-label>Start Pickup Date</mat-label>
                      <input matInput [matDatepicker]="dp1" formControlName="startDate" />
                      <mat-hint [class.disabled-pickup-date]="!isDateRestricted">MM/DD/YYYY</mat-hint>
                      <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                      <mat-datepicker #dp1></mat-datepicker>
                    </mat-form-field>
                  </div>
                  <div class="date-picker">
                    <mat-label [class.disabled-pickup-date]="!isDateRestricted">End Date</mat-label>
                    <mat-form-field appearance="fill">
                      <mat-label>End Pickup Date</mat-label>
                      <input matInput [matDatepicker]="dp2" formControlName="endDate" />
                      <mat-hint [class.disabled-pickup-date]="!isDateRestricted">MM/DD/YYYY</mat-hint>
                      <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                      <mat-datepicker #dp2></mat-datepicker>
                    </mat-form-field>
                  </div>
                </form>
              }
              @if (isDateRestricted && authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin"])) {
                <mat-radio-group
                  class="radio-group limited-quantity"
                  [(ngModel)]="isSellableQuantityEnabled"
                  (change)="limitedQuantityButton($event)"
                  name="limited-quantity">
                  <mat-radio-button [value]="false" [checked]="!isSellableQuantityEnabled" name="limited-quantity">
                    Unlimited Quantity
                  </mat-radio-button>
                  <mat-radio-button
                    checked
                    [value]="true"
                    [checked]="isSellableQuantityEnabled"
                    name="limited-quantity">
                    Limit Quantity for date range
                  </mat-radio-button>
                </mat-radio-group>
              }
              @if (isDateRestricted && isSellableQuantityEnabled) {
                <form [formGroup]="limitedQuantityForm">
                  <div class="sellable-quantity">
                    <mat-label [class.disabled-pickup-date]="!isDateRestricted">Total Sellable Quantity</mat-label>
                    <mat-form-field appearance="fill">
                      <input matInput type="number" formControlName="sellableQuantity" />
                    </mat-form-field>
                  </div>
                </form>
              }
            </div>
          </div>
          <div class="section handoff-restrictions">
            <mat-label>Available Handoff Types</mat-label>
            <div class="handoff-types" [formGroup]="handoffTypesForm">
              @if (getSelectedHandoffTypes().length < 1) {
                <span class="handoff-type-error">*At least 1 hand-off type must be selected</span>
              }
              <mat-checkbox class="handoff-type" formControlName="carryout">Carryout</mat-checkbox>
              <mat-checkbox class="handoff-type" formControlName="curbside">Curbside</mat-checkbox>
              <mat-checkbox class="handoff-type" formControlName="delivery">Delivery</mat-checkbox>
              <mat-checkbox class="handoff-type" formControlName="kiosk">Kiosk</mat-checkbox>
              <mat-checkbox class="handoff-type" formControlName="tableside">Tableside</mat-checkbox>
            </div>
          </div>
          <div class="section">
            <mat-label>Apply this import to multiple stores?</mat-label>
            <mat-radio-group class="radio-group" [(ngModel)]="isMultiStore" (change)="multiStoreButton($event)">
              <mat-radio-button [value]="true">
                Yes, I would like to apply this change to multiple stores.
              </mat-radio-button>
              <mat-radio-button checked [value]="false"> No, only apply changes to this store. </mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="button-container">
            <button mat-button color="warn" (click)="onNoClick()">Exit</button>
            @if (!isMultiStore) {
              <button
                mat-button
                matStepperNext
                mat-raised-button
                color="accent"
                (click)="importItemToFacilities()"
                [disabled]="!isClickable">
                Confirm
              </button>
            }
            @if (isMultiStore) {
              <button
                mat-button
                matStepperNext
                mat-raised-button
                color="accent"
                type="button"
                [disabled]="!isClickable">
                Select Stores
              </button>
            }
          </div>
        </form>
      </mat-step>
      @if (isMultiStore) {
        <mat-step [stepControl]="secondFormGroup" [editable]="true">
          <form [formGroup]="secondFormGroup">
            <ng-template matStepLabel>Select Stores</ng-template>
            <ng-template matStepContent>
              <multi-store-dropdown
                [(facilities)]="facilities"
                [currentFacilityId]="currentFacilityId"></multi-store-dropdown>
              <div class="button-container">
                <button mat-button matStepperPrevious type="button" [disabled]="!isClickable">Back</button>
                <button
                  mat-button
                  matStepperNext
                  mat-raised-button
                  color="primary"
                  (click)="importItemToFacilities()"
                  [disabled]="!isClickable">
                  Confirm
                </button>
              </div>
            </ng-template>
          </form>
        </mat-step>
      }
    </mat-stepper>
  </div>
</mat-dialog-content>
